<script>
export default {
  props: {
    forMobile: [Boolean, String],
  },
  computed: {
    getClass() {
      return {
        'help-logo--desktop': !this.forMobile,
      }
    },
  },
  methods: {
    handleHelpClick(e) {
      this.$emit("click", e);
    },
  },
};
</script>
<template lang='pug'>
a.help-logo(:class="getClass", @click='handleHelpClick($event)')
  svg.help-logo__svg(version="1.1" xmlns="http://www.w3.org/2000/svg", x="0px", y="0px", viewBox="0 0 300 230.9", style="enable-background:new 0 0 300 230.9;")
    path.help-logo__message-icon(d="M232.6,95.2V29c0-11.8-9.6-21.4-21.4-21.4H29.7C17.9,7.7,8.3,17.3,8.3,29v116.8c0,11.8,9.6,21.4,21.4,21.4h10.5v34.2c0,4.9,5.9,7.3,9.4,3.9l38.1-38.1h72.9C160.6,127.5,192.8,95.2,232.6,95.2z M70.4,103.4c-8.8,0-16-7.1-16-16s7.1-16,16-16c8.8,0,16,7.1,16,16S79.2,103.4,70.4,103.4z M120.5,103.4c-8.8,0-16-7.1-16-16s7.1-16,16-16s16,7.1,16,16S129.3,103.4,120.5,103.4zM154.6,87.5c0-8.8,7.1-16,16-16s16,7.1,16,16s-7.1,16-16,16S154.6,96.3,154.6,87.5z")
    path.help-logo__help-icon(d="M232.6,108.2c-32.6,0-59.1,26.4-59.1,59.1c0,32.6,26.4,59.1,59.1,59.1c32.6,0,59.1-26.4,59.1-59.1C291.7,134.7,265.2,108.2,232.6,108.2z M238.6,196.7c-1.6,1.6-3.6,2.4-6,2.4c-1.2,0-2.2-0.2-3.2-0.6c-1-0.4-1.9-1-2.7-1.7c-0.8-0.7-1.4-1.6-1.9-2.6c-0.5-1-0.7-2-0.7-3.2c0-1.1,0.2-2.1,0.6-3.2c0.4-1,1-1.9,1.8-2.6c0.8-0.7,1.7-1.3,2.7-1.8c1-0.4,2.1-0.6,3.3-0.6c1.2,0,2.2,0.2,3.2,0.6c1,0.4,1.9,1,2.7,1.7c0.8,0.7,1.4,1.6,1.8,2.6c0.4,1,0.6,2.1,0.6,3.2C241,193.2,240.2,195.1,238.6,196.7z M253,157.7c-0.5,1.4-1.1,2.8-2,4c-0.8,1.2-1.9,2.3-3,3.4c-1.2,1.1-2.5,2.2-4,3.3c-0.9,0.7-1.7,1.4-2.3,2c-0.6,0.6-1.1,1.2-1.4,1.8c-0.3,0.6-0.6,1.2-0.7,1.9c-0.1,0.7-0.2,1.5-0.2,2.4v2.2h-13.5v-3.3c0-1.5,0.1-2.8,0.4-4c0.3-1.2,0.7-2.3,1.3-3.2c0.6-1,1.3-1.9,2.1-2.9c0.8-0.9,1.8-1.9,3-2.9l2.9-2.7c1-0.9,1.8-1.8,2.5-2.7c0.7-1,1-2.1,1-3.4c0-1.8-0.6-3.3-1.7-4.4c-1.1-1.1-2.7-1.6-4.6-1.6c-2.4,0-4.2,0.8-5.4,2.5c-1.2,1.6-1.9,3.5-2,5.6l-13.7-1.5c0.3-3.1,1.1-5.8,2.4-8.2c1.2-2.4,2.8-4.3,4.8-5.9c2-1.6,4.2-2.7,6.7-3.5c2.5-0.8,5.1-1.2,7.9-1.2c2.6,0,5.1,0.3,7.6,1c2.5,0.7,4.6,1.7,6.5,3.1c1.9,1.4,3.4,3.2,4.6,5.4c1.2,2.2,1.7,4.8,1.7,7.8C253.7,154.6,253.5,156.3,253,157.7z")
</template>

<style>
@import '~import/index';

.help-logo {
  line-height: 40px;
  position: absolute;
  top: 12.5px;
  right: 15px;
  z-index: 2;
  height: 25px;
  cursor: pointer;
  visibility: visible;
  opacity: 1;
  text-align: center;
  background-color: transparent;

  @include mq(mf-md) {
    display: none;
  }

  &__svg {
    height: 100%;
  }

  &__message-icon {
    fill: $primaryColor;
  }

  &__help-icon {
    fill: $white;
  }

  &--desktop {
    display: inline-block;
    position: static;
    height: 30px;
    width: 40px;
    
    .help-logo__help-icon {
      fill: $secondaryColor;
    }
  }
}
</style>